import React, { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import StoryListing from '../storyListing/storyListing';
import { getAllCompanyPurchases } from '../../services/purchase/getCompanyPurchases';
import { getAllPurchaseCompanies } from '../../services/purchase/getCompanies';
import cookie from '../../cookieHelper/cookie';
import { auth as AuthObject } from '../../services/login';

export default function AddPurchaseStory() {
    const { centralCompanyId, purchaseId } = useParams();
    const [purchase, setPurchase] = useState(null);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    const [expired, setExpired] = useState(false);
    useEffect(() => {
        const controller = new AbortController();
        setPurchase(null);
        setError('');
        Promise.all([
            getAllCompanyPurchases(centralCompanyId, controller.signal),
            getAllPurchaseCompanies(controller.signal),
        ]).then(([result, companyResult]) => {
            if (controller.signal.aborted) return;
            const selected = result.purchases.find(item => item._id === purchaseId);
            if (!selected || selected.status !== 4 || !selected.origin) {
                setError('Select a published purchase with a platform to add stories.');
                return;
            }
            const company = companyResult.companies.find(item => String(item.centralCompanyId) === String(centralCompanyId));
            const companyName = company?.companyName || selected.companyName;
            if (!companyName) {
                setError('Unable to find the company name. Please try again.');
                return;
            }
            setPurchase({ ...selected, companyName });
        }).catch(err => {
            if (controller.signal.aborted) return;
            const code = String(err.response?.data?.status?.code);
            if (err.response?.status === 401 || ['10411', '10412', '10416', '10417'].includes(code)) {
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
                setExpired(true);
            } else setError('Unable to load purchase. Please try again.');
        });
        return () => controller.abort();
    }, [centralCompanyId, purchaseId, attempt]);
    if (expired) return <Navigate to="/" replace />;
    if (purchase) return <StoryListing key={purchaseId} purchaseContext={{
        ...purchase, centralCompanyId,
    }} />;
    return <main className="purchase-company-page">
        <Link to={`/companies/${centralCompanyId}/purchases`}>← Back to purchases</Link>
        {error ? <div role="alert"><p>{error}</p><button onClick={() => setAttempt(value => value + 1)}>Retry</button></div>
            : <p role="status">Loading purchase…</p>}
    </main>;
}
